<template>
  <div class="qdSignContract">
    <div class="header clear">
      <span class="fl_left">权限开通申请</span>
      <el-button class="fl_right" type="primary" @click="submitHandle">提交</el-button>
    </div>
    <el-scrollbar>
      <div class="wrapper">
        <div class="common_group">
          <div class="title">
            <img src="@/assets/images/informationIcon.png">
            <span>甲方信息</span>
          </div>
          <div class="common_readonly_template">
            <el-row>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <div>
                  <div class="label">委托方（甲方）</div>
                  <div class="text">锐捷网络股份有限公司</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <div>
                  <div class="label">法人代表</div>
                  <div class="text">黄奕豪</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <div>
                  <div class="label">联系人</div>
                  <div class="text">张硕</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <div>
                  <div class="label">联系人电话</div>
                  <div class="text">18611327828</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <div>
                  <div class="label">邮箱</div>
                  <div class="text">zhangshuo@ruijie.com.cn</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="18">
                <div>
                  <div class="label">地址</div>
                  <commonTooltip class="text" ref-name="qdSignContractAddress" content="福州市仓山区金山大道618号桔园洲工业园19#楼" />
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="common_group">
          <div class="title">
            <img src="@/assets/images/informationIcon.png">
            <span>乙方信息</span>
          </div>
          <el-form class="common_form" label-position="left" ref="basicInformationForm" :rules="rules" label-width="140px" :model="formData">
            <el-row>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="受托方（乙方）" prop="secondParty">
                  <el-input v-model="formData.secondParty" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="法人代表" prop="juridicalPerson">
                  <el-input v-model="formData.juridicalPerson" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="联系人" prop="contacts">
                  <el-input v-model="formData.contacts" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="联系人电话" prop="phone">
                  <el-input v-model="formData.phone" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="联系人邮箱" prop="email">
                  <el-input v-model="formData.email" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="地址" prop="address">
                  <el-input v-model="formData.address" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="开户行" prop="bank">
                  <el-input v-model="formData.bank" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="账户名" prop="accountName">
                  <el-input v-model="formData.accountName" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="账号" prop="accountNumber">
                  <el-input v-model="formData.accountNumber" @input="inputBoxFilter($event,'accountNumber')" />
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="税号" prop="taxPayerCode">
                  <el-input v-model="formData.taxPayerCode" @input="inputBoxFilter($event,'taxPayerCode')" maxlength="50" />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="common_group">
          <div class="title">
            <img src="@/assets/images/informationIcon.png">
            <span>框架协议</span>
            <span class="danger">注：请您务必仔细阅读此协议，提交后默认为同意该协议的所有内容</span>
          </div>
          <div class="protocolContent" v-html="agreementContent" />
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import commonTooltip from '@/components/commonTooltip';
import { qdSignContractApi } from '@/API/home';

export default {
  components: {
    commonTooltip
  },
  data () {
    let phoneNumberValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入联系人电话'));
      } else if (!/^[0-9]{7,}$/.test(value)) {
        callback(new Error('手机号格式有误'));
      } else {
        callback();
      }
    };
    return {
      rules: {
        secondParty: [
          { required: true, message: '请输入受托方', trigger: 'blur' }
        ],
        juridicalPerson: [
          { required: true, message: '请输入法人代表', trigger: 'blur' }
        ],
        contacts: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, validator: phoneNumberValidator, trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入联系人邮箱', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入地址', trigger: 'blur' }
        ],
        bank: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        accountName: [
          { required: true, message: '请输入银行账户名', trigger: 'blur' }
        ],
        accountNumber: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        taxPayerCode: [
          { required: true, message: '请输入税号', trigger: 'blur' }
        ]
      },
      formData: {},
      agreementContent: ''
    };
  },
  methods: {
    inputBoxFilter (val, key) {
      let numVal = val.replace(/\s+/g, '');
      this.$set(this.formData, key, numVal);
    },
    submitHandle () {
      this.$refs['basicInformationForm'].validate((valid) => {
        if (valid) {
          let { sysUser } = this.$store.state.userInfo;
          let params = {
            userId: sysUser.userId,
            userName: sysUser.userName,
            ...this.formData
          };
          this.$store.commit('setSubPageLoading', true);
          qdSignContractApi.setPdfDocument({ PdfInfo: params }).then(res => {
            if (res.status === '200') {
              this.$store.commit('setQdSignContractFileId', res.data);
              this.$store.commit(
                'setQdSignContractFormInfo',
                params
              );
              this.$router.push('/qdSignContractDetail');
            }
            this.$store.commit('setSubPageLoading', false);
           });
        }
      });
    },
    getQdElectronicSignature () {
      qdSignContractApi.getQdElectronicSignature().then(res => {
        if (res.status === '200') {
          this.agreementContent = res.data;
        }
      });
    }
  },
  mounted () {
    this.getQdElectronicSignature();
    if (!this.$store.state.qdSignContractFormInfo.contacts && sessionStorage.getItem('qdSignContractFormInfo')) {
      this.$store.commit(
        'setQdSignContractFormInfo',
        JSON.parse(sessionStorage.getItem('qdSignContractFormInfo'))
      );
    }
    if (this.$store.state.qdSignContractFormInfo.contacts) {
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem(
          'qdSignContractFormInfo',
          JSON.stringify(this.$store.state.qdSignContractFormInfo)
        );
      });
      this.formData = this.$store.state.qdSignContractFormInfo;
    }
  }
};
</script>

<style lang="scss" scoped>
.qdSignContract{
  width: 100%;
  height: 100%;
  >.header{
    width: 100%;
    padding: 13px 28px;
    line-height: 32px;
    background: #FFFFFF;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    color: #424C57;
    font-size: 16px;
    >span{
      cursor: pointer;
    }
  }
  > .el-scrollbar {
    width: 100%;
    height: 100%;
    margin-top: 58px;
    ::v-deep> .el-scrollbar__wrap {
      box-sizing: border-box;
      overflow-x: hidden;
      .wrapper {
        padding: 20px 28px;
        margin-bottom: 50px;
        .protocolContent{
          color: #354052;
          background: #FFFFFF;
          border: 1px solid #DEE1E7;
          padding: 20px;
          line-height: 22px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
